import { ActionIcon, Button, Menu } from "@mantine/core";
import React, { useState } from "react";
import { ChevronDown, Dots, Edit, Trash, Users } from "tabler-icons-react";

import { Project } from "types";

import DeleteProjectModal from "./DeleteProjectModal";
import EditProjectModal from "./EditProjectModal";
import EditMemberModal from "./ManageMembers";
import AddMemberModal from "./ManageMembers/AddMembersModal";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "hooks/useUser";
import { useProject } from "api/projectDetail/getProjectDetail";
import { PermissionButton } from "api/permission/buttonpermission";
import PermissionMenuItem from "api/permission/permissionMenuItem";

type ActionsBtnProps = {
  project: Project;
  orgId: string | undefined;
  projects: Project[];
  type: string;
  // projectId?: string;
};

function ActionsBtn({
  project,
  orgId,
  projects,
  type,
}: // projectId,
ActionsBtnProps) {
  const [editModalOpened, setEditModalOpened] = useState(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState(false);
  const [editMemberModalOpened, setEditMemberModalOpened] = useState(false);
  const [addMemberModalOpened, setAddMemberModalOpened] = useState(false);
  // const { projectId } = useParams();
  // const setSearchParams = useSearchParams()[1];
  // console.log("projectId", projectId);
  //
  const { user } = useUser();

  // const { data, isLoading, isError, isSuccess } = useProject(
  //   projectId!,
  //   user._id
  // );
  const navigate = useNavigate();
  return (
    <>
      <Menu shadow="md" width={200} position="bottom-end" withinPortal>
        <Menu.Target>
          {type === "grid" ? (
            <ActionIcon variant="subtle" color="gray" ml="auto">
              {" "}
              <Dots size={16} />
            </ActionIcon>
          ) : (
            <Button
              variant="outline"
              rightIcon={<ChevronDown size={16} />}
              pl={10}
              pr={6}
              miw={95}
              size="sm"
            >
              Actions
            </Button>
          )}
        </Menu.Target>
        <Menu.Dropdown>
          <PermissionMenuItem
            permission="project_management.edit"
            tooltipIfNo="You cannot edit this project"
            icon={<Edit size={18} />}
            onClick={() => setEditModalOpened(true)}
          >
            Edit Project
          </PermissionMenuItem>
          {/* <Menu.Item
            icon={<Edit size={18} />}
            onClick={() => setEditModalOpened(true)}
          >
            Edit Project
          </Menu.Item> */}

          <Menu.Item
            icon={<Users size={18} />}
            onClick={() => setAddMemberModalOpened(true)}
          >
            Add Members
          </Menu.Item>
          <PermissionMenuItem
            permission="project_management.edit"
            tooltipIfNo="You cannot edit members"
            icon={<Edit size={18} />}
            onClick={() => setEditMemberModalOpened(true)}
          >
            Edit Members
          </PermissionMenuItem>
          {/* <Menu.Item
            icon={<Edit size={18} />}
            onClick={() => setEditMemberModalOpened(true)}
          >
            Edit Members
          </Menu.Item> */}
          <PermissionMenuItem
            permission="project_management.delete"
            tooltipIfNo="You cannot delete this project"
            icon={<Trash size={18} />}
            color="red.8"
            onClick={() => setDeleteModalOpened(true)}
          >
            Delete Project
          </PermissionMenuItem>
          <PermissionMenuItem
            permission="project_management.viewDetails"
            tooltipIfNo="You cannot view details"
            icon={<Edit size={18} />}
            onClick={() =>
              navigate(`/project-detail/${project._id}/userId=${user._id}`)
            }
          >
            Project Details
          </PermissionMenuItem>
        </Menu.Dropdown>
      </Menu>
      <EditProjectModal
        opened={editModalOpened}
        onClose={() => setEditModalOpened(false)}
        project={project}
        orgId={orgId}
      />
      <DeleteProjectModal
        opened={deleteModalOpened}
        onClose={() => setDeleteModalOpened(false)}
        projectId={project._id}
        orgId={orgId}
      />
      <EditMemberModal
        opened={editMemberModalOpened}
        onClose={() => setEditMemberModalOpened(false)}
        project={project}
        orgId={orgId}
        projects={projects}
      />

      <AddMemberModal
        opened={addMemberModalOpened}
        onClose={() => setAddMemberModalOpened(false)}
        project={project}
      />
    </>
  );
}

export default ActionsBtn;
